import { useEffect, useRef, useState, useCallback } from 'react';
import { weightAPI } from '../services/api';

const STORAGE_KEY = 'buzzer_sound_enabled';

export default function useBuzzer() {
  const passAudioRef = useRef(null);
  const failAudioRef = useRef(null);
  const lastSeenIdRef = useRef(null);
  const isFirstRunRef = useRef(true);

  // localStorage मधून सुरुवातीची value वाचा (default: true = ON)
  const [soundEnabled, setSoundEnabled] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === null ? true : saved === 'true';
  });

  // हे ref ठेवतो जेणेकरून interval callback मध्ये नेहमी latest value मिळेल
  const soundEnabledRef = useRef(soundEnabled);
  useEffect(() => {
    soundEnabledRef.current = soundEnabled;
  }, [soundEnabled]);

  useEffect(() => {
    passAudioRef.current = new Audio('/sounds/pass-buzzer.mpeg');
    failAudioRef.current = new Audio('/sounds/fail-buzzer.mpeg');
  }, []);

  const playBuzzer = useCallback((result) => {
    if (!soundEnabledRef.current) return;
    const audio = result === 'Pass' ? passAudioRef.current : failAudioRef.current;
    if (!audio) return;
    audio.currentTime = 0;
    audio.play().then(() => console.log('Buzzer played successfully')).catch(err => console.warn('Buzzer blocked:', err.message));
  }, []);

  // Toggle बटणावर क्लिक झाल्यावर हे चालेल — user gesture असल्यामुळे
  // इथेच audio unlock पण होऊन जातं (autoplay restriction साठी)
  const toggleSound = useCallback(() => {
    setSoundEnabled(prev => {
      const next = !prev;
      localStorage.setItem(STORAGE_KEY, String(next));

      if (next) {
        // ON केल्यावर audio "unlock" करा (silent play+pause) जेणेकरून
        // पुढचे buzzer browser कडून block होणार नाहीत
        [passAudioRef.current, failAudioRef.current].forEach(audio => {
          if (!audio) return;
          audio.play().then(() => {
            audio.pause();
            audio.currentTime = 0;
          }).catch(() => { });
        });
      }
      return next;
    });
  }, []);

  return { soundEnabled, toggleSound, playBuzzer };
}